import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`

export const InputBox = styled.div`
  margin-bottom: 20px;
`
export const InputTitle = styled.div`
  font-size: 14px;
  color: #280D5F;
  margin-bottom: 10px;
`
export const WarnTip = styled.div`
  font-size: 13px;
  color: #280D5F;
  line-height: 23px;
  padding: 15px 15px;
  background: #FFF6E8;
  border: 1px solid #FFC323;
  border-radius: 12px;
  margin-bottom: 20px;
`

export const TopBox = styled.div`
  padding: 20px;
  text-align: center;
`

export const TriggerText = styled.div`
  font-size: 12px;
  color: #FF8F17;
  text-align: right;
`

export const HostingText = styled.div`
  font-size: 24px;
  color: #1EC7D3;
  font-weight: bold;
  span{
    font-size: 16px;
  }
`

export const DescText = styled.div`
  font-size: 13px;
  color: #7A6EAA;
`

export const ButtonText = styled.div`
  font-size: 13px;
  color: #1EC7D3;
  font-weight: bold;
`

export const CommonText = styled.div`
  font-size: 13px;
  color: #280D5F;
`

export const ContentBox = styled.div`
  padding: 14px;
  background: #FAF9FA;
  border-top: 1px solid #E7E3EB;
`

export const EarningCountdown = styled.div`
  padding: 20px;
  background: linear-gradient(180deg, #7645D8, #472B7D);
  border-radius: 16px;
`
export const EarningText = styled.div`
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 22px;
  font-wight: bold;
`
export const CountdownBox = styled.div`
  background: linear-gradient(90deg, #3A1D75, #472B81);
  border-radius: 16px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  color: #fff;
  margin-bottom: 20px;
`
export const CountdownContent = styled.div`
  height: 46px;
  color: #280D5F;
  font-size: 14px;
  font-weight: bold;
  line-height: 46px;
  background: linear-gradient(90deg, #FECD0D 0.146484375%, #FFA849 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  span{
    font-size: 20px;
    margin-left: 3px;
  }
`
export const IncomeBox = styled.div`
  padding: 20px 12px;
  background: #FAF9FA;
  border: 1px solid #EEEAF4;
  background: #fff;
  border-radius: 16px;
  margin: 16px 0;
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: #280D5F;
  line-height: 20px;
  padding: 28px 24px;
  background: linear-gradient(103deg, #F2ECF2, #E8F2F6);
`

export const Icon = styled.img<{ width: string, height:  string}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`
export const LockInputBox = styled.div`
  background: #EEEAF4;
  height: 46px;
  border-radius: 16px;
  border: 1px solid #D7CAEC;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  position: relative;
`

export const LockText = styled.div`
  font-size: 14px;
  color: #280D5F;
  font-weight: bold;
`

export const TabBox = styled.div`
  font-size: 13px;
  color: #7A6EAA;
  font-weight: bold;
  padding: 18px 20px;
  border-bottom: 1px solid #E7E3EB;
`

export const TabItem = styled.div`
  &.active{
    font-size: 15px;
    color: #311765;
  }
`
export const RecordBox = styled.div`
  padding: 15px;
`
export const RecordItem = styled.div`
  padding: 0 15px;
  border-radius: 10px;
  background: #FAF9FA;
`
export const RecordSection = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #E7E3EB;
`
export const NoMore = styled.div`
  padding: 50px 0;
  font-size: 16px;
  color: #BDC2C4;
  text-align: center;
`
export const HostIcon = styled.img<{ width: string, height: string}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  display: block;
  top: -45px;
  position: absolute;
  z-index: 100;
  left: -13px;
`
export const HostIconBox = styled.div`
  position: relative; 
  width:100%;
  height: 30px;
  max-width: 436px;
  margin: 0 auto  10px;
`
